import { ConversationalChatVisibility } from '@klant/conversational-connector/klant-conversational-connector.model';

import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './conversational-link.content.json';

@Component({
    selector: 'conversational-link',
    templateUrl: './conversational-link.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConversationalLinkComponent {
    private readonly apContentService = inject(ApContentService);

    public readonly changeConversationalStatus = output<ConversationalChatVisibility>();

    public constructor() {
        this.apContentService.addContentItems(content);
    }

    public onOpenConversational(): void {
        this.changeConversationalStatus.emit(ConversationalChatVisibility.OPEN);
    }
}
